<template>
  <div class="edit-cv-main-composing" @click.stop="updateFontState(false)">
    <!-- <div class="model model-top">
      <div class="option" @click="download">
        <i class="iconfont icondownload"></i>
        <p>下载</p>
      </div>
      <div class="option" @click="sendCv">
        <i class="iconfont iconnavigation"></i>
        <p>投递</p>
      </div>
      <div class="option" @click="share">
        <i class="iconfont iconexternal-link"></i>
        <p>分享</p>
      </div>
    </div> -->
    <!-- <div class="model" style="position: relative: z-index: 2;">
      <div class="control">
        <div :class="['control-menu', controlOption === 0 ? 'active' : '']" @click.stop="controlOption = 0">样式</div>
        <div :class="['control-menu', controlOption === 1 ? 'active' : '']" @click.stop="controlOption = 1">排版</div>
        <div :class="['control-menu', controlOption === 3 ? 'active' : '']" @click.stop="controlOption = 3">全新</div>
      </div>
    </div> -->

    <div class="model model-content">
      <div class="scroll">

        <div>

          <!-- 智能一页、智能排序 -->
          <div class="content">
            <div class="auto-page-btn" :class="['auto-btn']" @click="autoOne">
              <span>{{!autoOnePage ? '智能一页' : '取消一页'}}</span>
            </div>
            <div class="auto-sort-btn" :class="['auto-btn']" @click="cvAutoSort(true)">
              <span>智能排序</span>
            </div>
          </div>

          <!-- 简历认证-->
          <div class="headerTitle flex-c-start">
            <span>简历认证</span>
            <img src="https://files.wondercv.com/pc/jobscan/jobscan-new-icon1.png" width="39" height="16"/>
          </div>
          <div class="title">联合 HR 为简历背书，通过率更高</div>
          <div class="content layouts">
            <button :class="[ (cvDetail.format_info.watermark === '') ? 'action' : '']" @click="selectResumeCertification({watermark :''})">
              <i class="buttonicon iconfont iconbuxianshi"></i>
              <span>不显示</span>
            </button>
            <button :class="[ cvDetail.format_info.watermark === 'basic' ? 'action' : '']" @click="selectResumeCertification({watermark :'basic'})">
              <i class="buttonicon iconfont iconchaojijianli"></i>
              <span>超级简历</span>
            </button>
            <button :class="[ cvDetail.format_info.watermark === 'better' ? 'action' : '', score < 80 ? 'disabled' : '']" :disabled="score < 80" @click="selectResumeCertification({watermark :'better'})">
              <i class="buttonicon iconfont iconyouxiujianli"></i>
              <span>优秀简历</span>
              <div class="hover-tooltip hover-tooltip-80">
                简历分数达到80分可使用此标识，请先完善简历
              </div>
            </button>
            <button :class="[ cvDetail.format_info.watermark === 'best' ? 'action' : '', score < 95 ? 'disabled' : '']" :disabled="score < 95" @click="selectResumeCertification({watermark :'best'})">
              <i class="buttonicon iconfont icondingjianjianli"></i>
              <span>顶尖简历</span>
              <div class="hover-tooltip hover-tooltip-95">
                简历分数达到95分可使用此标识，请先完善简历
              </div>
            </button>

          </div>
          <!-- 头部排版 -->
          <div class="headerTitle">头部排版</div>

          <!--
            format_pref_show_attr_name，也就是 profile.show_attr_name，后端返回true和false来判断基本信息是否加前缀名，
            由于现在又新加了一项：显示图标，所以这个值的类型需要改，和后端讨论一下。
          -->
          <div class="title">基本信息</div>
          <div class="content layouts">
            <button :class="[profile.show_attr_name === 1 ? 'action' : '']"
                    @click="selectInfo(1)">
              <i class="buttonicon iconfont iconwenzi"></i>
              <span>文字</span>
            </button>
            <button :class="[profile.show_attr_name === 2 ? 'action' : '']"
                    @click="selectInfo(2)">
              <i class="buttonicon iconfont icontubiao"></i>
              <span>图标</span>
            </button>
            <button :class="[profile.show_attr_name === 0 ? 'action' : '']"
                    @click="selectInfo(0)">
              <i class="buttonicon iconfont iconjianjie"></i>
              <span>简洁</span>
            </button>
          </div>

          <!--
            cvDetail.format_info.head_format，头部基本信息的对齐方式，因为新加了整体居中，需要与后端沟通，新加一个字段
          -->
          <div class="title">布局</div>
          <div class="content layouts">
            <button :class="[cvDetail.format_info.head_format === 'center' ? 'action' : '']"
                    @click="setFormatInfo({head_format:'center'})">
              <i class="buttonicon iconfont iconjuzhong"></i>
              <span>居中</span>
            </button>
            <button :class="[cvDetail.format_info.head_format === 'left' ? 'action' : '']"
                    @click="setFormatInfo({head_format:'left'})">
              <i class="buttonicon iconfont iconjuzuo"></i>
              <span>居左</span>
            </button>
            <button :class="[cvDetail.format_info.head_format === 'body_center' ? 'action' : '']"
                    @click="setFormatInfo({head_format:'body_center'})">
              <i class="buttonicon iconfont icondatouxiang"></i>
              <span>大头像</span>
            </button>
          </div>

          <!--
            新加 是否显示简历顶部线条的字段 和 线条颜色的字段，需要与后端沟通
          -->
          <div class="title">顶部</div>
          <div class="content layouts">
            <button :class="[cvDetail.format_info.top_format === 'default' ? 'action' : '']"
                    @click="setCvHeaderLineShow('default', false)">
              <i class="buttonicon iconfont iconmoren"></i>
              <span>默认</span>
            </button>
            <button :class="[cvDetail.format_info.top_format === 'line' ? 'action' : '']"
                    @click="setCvHeaderLineShow('line', true)">
              <i class="buttonicon iconfont iconxinzhi"></i>
              <span>信纸</span>
            </button>
            <template v-if="isShowCvHeaderLine || cvDetail.format_info.top_format === 'line'">
              <div :class="['theme-header-line', 'theme', `theme-${index}`, (cvDetail.format_info.top_line_color === item) && !cvDetail.format_info.top_line_select_color ? 'action' : '']"
                   v-for="(item, index) in HEADER_LINE_THEME"
                   :key="item"
                   :style="{background: item}"
                   @click="setFormatInfo({top_line_select_color: false, top_line_color: item})">
                <i class="iconfont iconcheck"></i>
              </div>
              <div :class="['theme', 'theme-select', cvDetail.format_info.top_line_select_color ? 'action' : '']">
                <i class="iconfont iconcheck"></i>
                <input type="color" v-model="cvDetail.format_info.top_line_color" @input="setFormatInfo({top_line_select_color: true, top_line_color: cvDetail.format_info.top_line_color})">
              </div>
            </template>
          </div>
          <!-- 头部排版 -->

          <!-- 正文排版 -->
          <div class="headerTitle">正文排版</div>

          <div class="title">标题样式</div>
          <div class="content layouts">
            <button :class="[cvDetail.format_info.title_format === 'default' ? 'action' : '']"
                    @click="changeTileFormat('default')">
              <i class="buttonicon iconfont iconzhuanye"></i>
              <span>专业</span>
            </button>
            <button :class="[cvDetail.format_info.title_format === 'strip' ? 'action' : '']"
                    @click="changeTileFormat('strip')">
              <i class="buttonicon iconfont iconqingxin"></i>
              <span>清新</span>
            </button>
            <button :class="[cvDetail.format_info.title_format === 'tag' ? 'action' : '']"
                    @click="changeTileFormat('tag')">
              <i class="buttonicon iconfont icontuchu"></i>
              <span>突出</span>
            </button>
            <button :class="[cvDetail.format_info.title_format === 'icon' ? 'action' : '']"
                    @click="changeTileFormat('icon')">
              <i class="buttonicon iconfont icontubiao1"></i>
              <span>图标</span>
            </button>

            <div :class="['theme', `theme-${index}`, (cvDetail.format_info.title_color === item) && !cvDetail.format_info.title_select_color ? 'action' : '']"
                  v-for="(item, index) in THEME"
                  :key="item"
                  :style="{background: item}"
                  @click="setFormatInfo({title_select_color: false, title_color: item})">
              <i class="iconfont iconcheck"></i>
            </div>
            <div v-show="cvDetail.format_info.title_format !== 'icon'" :class="['theme', 'theme-select', cvDetail.format_info.title_select_color ? 'action' : '']">
              <i class="iconfont iconcheck"></i>
              <input type="color" v-model="cvDetail.format_info.title_color" @input="setFormatInfo({title_select_color: true, title_color: cvDetail.format_info.title_color})">
            </div>

          </div>

          <div class="box">
            <div class="menu">
              <div class="title">字体</div>
              <div class="con">
								<!-- 自制字体选择菜单 -->
								<div class="mySelect cursor_p pr">
									<div class="model f_13 ellipsis pr" v-if="cvDetail.format_info.font" @click.stop="updateFontState(!showFontState)">{{ cvDetail.format_info.font | fontFamily(self) }}</div>
									<div class="model f_13 placeholder pr" v-else  @click.stop="updateFontState(!showFontState)" >请选择</div>
									<i class="el-icon pa el-icon-arrow-up" :class="[showFontState?'active':'']" @click.stop="updateFontState(!showFontState)"></i>

									<div class="fontList pa bg_fff" :class="cvDetail.basic_info.lang==='cn'?'widthAuto':''" v-if="showFontState">
										<div class="popper__arrow pa"></div>
										<template v-for="item in userFontFamily[cvDetail.basic_info.lang]">
											<div class="font f_14 color_60" :class="[item.id === font?'color_red':'']" :key="item.id" v-if="item.hasFont" @click.stop="toggleFont(cvDetail.basic_info.lang,item)"><span :class="['iconfont',item.iconfont]"></span></div>
											<el-tooltip v-else :key="item.id" class="item" effect="dark" placement="right">
												<div slot="content">系统中暂无此字体<br/>字体效果下载简历生效</div>
												<div class="font f_14 color_60" :class="[item.id === font?'color_red':'']" @click.stop="toggleFont(cvDetail.basic_info.lang,item)"><span :class="['iconfont',item.iconfont]"></span></div>
											</el-tooltip>
										</template>
									</div>
								</div>
                <!-- <el-tooltip class="item" effect="dark" content="字体效果需下载简历查看" placement="top">
                  <el-select v-model="font" placeholder="请选择" @change="setFormatInfo({font})">
                    <el-option
                        v-for="item in FONT[cvDetail.basic_info.lang]"
                        :key="item.id"
                        :value="item.id"
                        :label="item.cnName">
                    </el-option>
                  </el-select>
                </el-tooltip> -->
              </div>
            </div>
            <div class="menu">
              <div class="title">字号</div>
              <div class="con composing-select">
                <el-select v-model="cvDetail.format_info.font_size" placeholder="请选择" @change="changeFontSize">
                  <el-option
                      v-for="item in FONT_SIZE"
                      :key="item"
                      :value="item"
                      :label="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="box">
            <div class="menu">
              <div class="title">行距</div>
              <div class="con composing-select">
                <el-select v-model="cvDetail.format_info.line_spacing" placeholder="请选择" @change="setFormatInfo({line_spacing: cvDetail.format_info.line_spacing})">
                  <el-option
                      v-for="item in LINE_HEIGHT"
                      :key="item"
                      :value="item"
                      :label="item">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="menu">
              <div class="title">页边距</div>
              <div class="con composing-select">
                <el-select v-model="cvDetail.format_info.page_margin" placeholder="请选择" @change="setFormatInfo({ page_margin: cvDetail.format_info.page_margin })">
                  <el-option
                      v-for="item in PAGE_PADDING"
                      :key="item"
                      :value="item"
                      :label="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="title">页面尺寸</div>
          <div class="content layouts">
            <button :class="[cvDetail.format_info.page_size === 'a4' ? 'action' : '']"
                    @click="setFormatInfo({page_size:'a4'})">
              <span>A4</span>
            </button>
            <button :class="[cvDetail.format_info.page_size === 'letter_size' ? 'action' : '']"
                    @click="setFormatInfo({page_size:'letter_size'})">
              <span>Letter Size</span>
            </button>
          </div>
          <!-- 正文排版 -->

          <!-- 文本格式 -->
          <div class="headerTitle">文本格式</div>

          <div class="title">日期时间</div>
          <div class="content layouts">
            <button :class="[cvDetail.format_info.time_format === 'default' ? 'action' : '']"
                    @click="setFormatInfo({time_format: 'default'})">
              <span>2021年1月</span>
            </button>
            <button :class="[cvDetail.format_info.time_format === 'number' ? 'action' : '']"
                    @click="setFormatInfo({time_format: 'number'})">
              <span>2021.01</span>
            </button>
          </div>

          <div class="title">经历标题</div>
          <div class="content layouts">
            <button :class="[cvDetail.format_info.body_format === 'two_line' ? 'action' : '']"
                    @click="setFormatInfo({body_format: 'two_line'})">
              <span>双行标题</span>
            </button>
            <button :class="[cvDetail.format_info.body_format === 'one_line' ? 'action' : '', {'disabled': hasWorkSubItem }]"
                    @click="hasWorkSubItem ? null : setFormatInfo({body_format: 'one_line'})">
              <span>单行标题</span>
            </button>
          </div>
          <div class="content content-list" v-if="cvDetail.format_info.body_format === 'two_line'">
            <cv-radio v-model="cvDetail.format_info.format_priority" :list="priorityList" :disabled="cvDetail.format_info.body_format === 'one_line'"
                      @change="body_format === 'one_line' ? null :setFormatInfo({format_priority: cvDetail.format_info.format_priority})"/>
          </div>
          <div class="content content-list" v-if="cvDetail.format_info.body_format === 'one_line'">
            <cv-radio v-model="cvDetail.format_info.punctuation_format" :disabled="cvDetail.format_info.body_format === 'two_line'"
                      :list="punctuation_format_list"
                      @change="body_format === 'two_line' ? null :setFormatInfo({punctuation_format: cvDetail.format_info.punctuation_format})"/>
          </div>
          <!-- 文本格式 -->
          <div class="common-tips flex-c">
            同一公司添加多段职位信息时仅支持【双行标题-地点优先】样式
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import { mapState, mapMutations, mapActions } from 'vuex'
	import api from '@/api'
	import { dealSignatrue, routerTo } from '@/assets/js/util'
	import { THEME, HEADER_LINE_THEME, FONT_SIZE, LINE_HEIGHT, PAGE_PADDING } from '@/assets/js/const'

	import cvRadio from '@/components/base/cvRadio'

	const getNum = data => {
		return data.replace(/(\d*)?\w.*/gim, '$1')
	}
	export default {
		name: 'composing',
		components: {
			cvRadio
		},
		data () {
			return {
				self:this,
        THEME,
        HEADER_LINE_THEME,
				FONT_SIZE,
				LINE_HEIGHT,
				PAGE_PADDING,
				fontSize: '12pt',
				lineHeight: 12,
				font: '',
				padding: '',
				info: 1,
				controlOption: 0,
				autoOnePageState:false,//是否正在进行一页纸
				// 全部信息列表
				infoList: [
					{
						value: 1,
						content: '<div style="color: #606060;">显示信息名称</div><div style="color: #909090;font-size: 12px;margin-top: 10px;">（电话：1**********）</div>'
					},
					{
						value: 0,
						content: '<div style="color: #606060;">不显示信息名称</div><div style="color: #909090;font-size: 12px;margin-top: 10px;">（1**********）</div>'
					}
				],
				// 时间格式
				dateList: [
					{
						value: 'default',
						content: '<div style="color: #606060;">文字格式</div><div style="color: #909090;font-size: 12px;margin-top: 10px;">（2019年1月-2019年2月）</div>'
					},
					{
						value: 'number',
						content: '<div style="color: #606060;">数字格式</div><div style="color: #909090;font-size: 12px;margin-top: 10px;">（2019.01-2019.02）</div>'
					}
				],
				// 时间地址优先
				priorityList: [
					{
						value: 'time',
						content: '<div style="color: #606060;">时间优先</div>'
					},
					{
						value: 'city',
						content: '<div style="color: #606060;">地点优先</div>'
					}
				],
				// 标题, 一行标题
				titleList: [
					{
						value: 'two_line',
						content: '<div style="color: #606060;">两行标题</div><div style="color: #909090;font-size: 12px;margin-top: 10px;">（显示城市）</div>'
					},
					{
						value: 'one_line',
						content: '<div style="color: #606060;">一行标题</div><div style="color: #909090;font-size: 12px;margin-top: 10px;">（不显示城市）</div>'
					}
				],
				// 分隔符
				punctuation_format_list: [
					{
						value: 'show_punctuation',
						content: '<div style="color: #606060;">使用分隔符号</div>'
					},
					{
						value: 'not_show_punctuation',
						content: '<div style="color: #606060;">不使用分隔符号</div>'
					}
				],
				format_pref_show_attr_name: 1,
				time_format: 'default', // 日期格式 number
				format_priority: 'time', // 时间优先
				body_format: 'two_line', // 两行标题
        punctuation_format: 'show_punctuation', // 显示分隔符
        isShowCvHeaderLine: false
			}
		},
		computed: {
			...mapState('cvs', [ 'cvs', 'cv', 'downloadCv' ]),
			...mapState('editor', [ 'cvToken', 'cvDetail', 'currentInfo', 'works', 'orgs', 'edus', 'backUpFormatInfo', 'profile', 'backUpProfile', 'autoOnePage', 'onePageFunction', 'score', 'hasWorkSubItem' ]),
			...mapState('experience', [ 'showFontState','userFontFamily' ]),
			isMentorEditor () {
				return window.location.href.includes('mentor')
			}
		},
		created () {
			let { font, line_spacing, font_size, page_margin, time_format, format_priority, body_format, punctuation_format, } = this.cvDetail.format_info
			this.font = font
			this.fontSize = font_size ? `${ font_size }pt` : ''

			this.lineHeight = line_spacing
			this.padding = page_margin
			this.time_format = time_format
			this.format_priority = format_priority
			this.body_format = body_format
			this.punctuation_format = punctuation_format

      // this.format_pref_show_attr_name = this.profile.show_attr_name ? 1 : 0;
			this.format_pref_show_attr_name = this.profile.show_attr_name

		},
    watch:{
      score(value, old){
        if(value > old) return;
        if(this.cvDetail.format_info.watermark){
          this.selectResumeCertification({watermark : value < 80 ?  'basic'  : (value > 95 ? 'best' : 'better') })
        }
      }
    },
    mounted () {
      // 获取工作经历
      setTimeout(() => {
        let works = this.$store.state.editor.works
        // console.log(works,"=====================>works")
        works.forEach(item => {
          if (item.is_sub_item) {
            this.updateWorkHasSubItem(true)
          }
        })
      },2000)
    },
		methods: {
			...mapActions('editor', [ 'cvAutoSort' ]),
			...mapMutations('editor', [ 'setCvDetail', 'setBackUpFormatInfo', 'setProfileData', 'setBackUpProfile', 'setAutoOnePage','setOldLineHeight', 'updateWorkHasSubItem' ]),
			...mapMutations('experience', [ 'updateSidebarOption', 'updateFontState', ]),
      // 切换简历 标题样式（类型）
      changeTileFormat (type) {
        this.setFormatInfo({title_format: type})
        // 如果选择了图标标题，并且这个时候标题颜色选择的自定义颜色，因为图标标题没有自定义颜色选项，所以需要把标题颜色重置为默认值
        if (type === 'icon' && this.cvDetail.format_info.title_select_color) {
          this.setFormatInfo({title_select_color: false, title_color: '#000000'})
        }
      },
			// 一页纸
			autoOne () {
				//增加半秒延迟，防止重复频繁点击
				if(this.autoOnePageState){
					return false;
				}
				this.autoOnePageState = true;
				this.onePageFunction(true)
				setTimeout(() => {
					this.autoOnePageState = false;
				}, 1000);
			},
			// 投递
			sendCv () {
				routerTo(this.cv.send_to_email_url, '_blank')
			},
			share () {
				let alertData = {
					show: true,
					type: 'shareCv',
					shareUrl: `${ process.env.HOST_ROOT }/cvs/${ this.cv.base.token }/share`
				}
				this.$store.dispatch('app/setAlertData', alertData)
			},
			download () {
				this.downloadCv()
			},

			//更改format_info
			setFormatInfo (options) {
				//当前模块要有 key，value
				let cvDetail = JSON.parse(JSON.stringify(this.cvDetail))
				//同步数据
				Object.keys(options).forEach(key => {
					cvDetail.format_info[key] = options[key]
					if(key==='line_spacing'){
						//保存行距
						this.setOldLineHeight(options[key])
					}
				})
				//同步到vuex中
				this.setCvDetail(cvDetail);

				//触发保存
				this.submit();
			},
			//修改字号
			changeFontSize () {
				this.setFormatInfo({ font_size: getNum(this.cvDetail.format_info.font_size) })
			},
			// 切换是否显示信息名称
			async selectInfo (value) {
        // this.profile.show_attr_name = value === 1
				this.profile.show_attr_name = value
				//修改基本信息设置
				this.setProfileData(this.profile);
				try {
					//检测是否有profile数据
					if (this.profile.id) {
						let res = await api.cvsEditor.editProfile(this.cvToken, this.profile);
						if (res.code === 1000) {
							// this.$message.success('保存成功')
						} else {
							this.$message.success(res.message)
						}
					}

				} catch (error) {

				}
			},
      async selectResumeCertification(options){

        const scrollEl = document.querySelector('.cvs-component')
        const firstPage = document.querySelector('.page-index-1')
        const rect = firstPage.getBoundingClientRect()
        const clientHeight = document.body.clientHeight
        scrollEl.scrollTo({top: clientHeight > rect.height ? 0 : (rect.height - clientHeight) + 100, behavior: 'smooth'})
        //当前模块要有 key，value
        let cvDetail = JSON.parse(JSON.stringify(this.cvDetail))
        //同步数据
        Object.keys(options).forEach(key => {
          cvDetail.format_info[key] = options[key]
          if(key==='line_spacing'){
            //保存行距
            this.setOldLineHeight(options[key])
          }
        })
        //同步到vuex中
        this.setCvDetail(cvDetail);

        //触发保存
        this.submit();

      },

			// 保存
			async submit () {
				let { kind } = this.cvDetail.basic_info
				if (kind === 'template' || kind === 'sample') {
					this.$message.success('保存成功')
					//修改基本信息备份基本信息设置
					this.setBackUpProfile(JSON.parse(JSON.stringify(this.profile)))
					//修改简历设置备份
					this.setBackUpFormatInfo(JSON.parse(JSON.stringify(this.cvDetail.format_info)))
					return false
				}
				try {
					let data = {
						operation_type: 'update_format_info',
						format_info: this.cvDetail.format_info
					}
					let res = {}
					if (this.isMentorEditor) {
						res = await api.cvsEditor.updatedMentorCvInfo(this.cvToken, data)
					} else {
						res = await api.cvsEditor.updatedCvInfo(this.cvToken, data);
					}
					//检测是否有profile数据
					// if (this.profile.id && this.controlOption === 1) {
					// 	let profileRes = await api.cvsEditor.editProfile(this.cvToken, this.profile)
					// }
					if (res.code === 1000) {
						// this.$message.success('保存成功')
						//修改基本信息备份基本信息设置
						this.setBackUpProfile(JSON.parse(JSON.stringify(this.profile)))
						//修改简历设置备份
						this.setBackUpFormatInfo(JSON.parse(JSON.stringify(this.cvDetail.format_info)))
						//当前右侧大tab选择类型置为空
          	// this.updateSidebarOption('');
					} else {
						this.$message.success(res.message)
					}
				} catch (error) {
					this.$message.success('修改失败')
				}
				//   // 简历token  String
				//   cv_token: this.cv.base.token,
				//   // 主题色  String
				//   theme_color: this.cv.base.theme_color,
				//   // 字体  String
				//   font: this.cv.base.font,
				//   // 字号  String
				//   font_size: this.cv.base.font_size,
				//   // 行距  String
				//   line_spacing: this.cv.base.line_spacing,
				//   // 页边距  String
				//   page_margin: this.cv.base.page_margin,
				//   // 排版格式  String
				//   head_format: this.cv.base.head_format,
				//   // 数字格式  String
				//   time_format: this.cv.base.time_format,
				//   // 地点优先  String
				//   format_priority: this.cv.base.format_priority,
				//   // 一行标题  String
				//   body_format: this.cv.base.body_format,
				//   // 分隔符号  String
				//   punctuation_format: this.cv.base.punctuation_format,
				//   // 显示名称  String
				//   // show_attr_name: this.cv.base.show_attr_name,
				//   // 纸张大小
				//   page_size: this.cv.base.page_size,
				//   //
				//   show_attr_name: this.format_pref_show_attr_name === 1 ? 'true' : 'false'
			},
			//取消
			close () {
				//把备份数据同步到当前数据中
				let cvDetail = JSON.parse(JSON.stringify(this.cvDetail))
				cvDetail.format_info = this.backUpFormatInfo
				//同步到vuex中
				this.setCvDetail(cvDetail)

				//还原基本信息设置
				this.setProfileData(JSON.parse(JSON.stringify(this.backUpProfile)))

				//当前右侧大tab选择类型置为空
				this.updateSidebarOption('')
			},
			//切换字体
			toggleFont(lang,item){
				// if(!item.hasFont){
				// 	return false;
				// }
				this.font = item.id;
				this.setFormatInfo({font:this.font});
				//更新下拉菜单打开状态
				this.updateFontState(false)
      },
      // 设置 顶部线条 显示
      setCvHeaderLineShow (type, flag) {
        this.isShowCvHeaderLine = flag
        this.setFormatInfo({top_format: type})
      }
		},
		filters:{
			fontFamily:function(value, self){
				let { lang } = self.cvDetail.basic_info;
				return self.userFontFamily[lang].filter(item=>item.id===value)[0]?.cnName
			}
		},
	}
</script>
<style lang="scss" scoped>
  @import 'composing';
  .hover-tooltip{
    display: none;
  }
  .disabled{
    border: 1px solid #ececec;
    color: #CFCFCF !important;
    cursor: not-allowed !important;
    position: relative;
    .hover-tooltip{
      display: none;
      position: absolute;
      width: 262px;
      height: 64px;
      top: 48px;
      background: #505667;
      border-radius: 4px;
      padding: 12px 16px;
      line-height: 20px;
      font-weight: 400;
      color: #FFFFFF;
      font-size: 14px;
      box-sizing: border-box;
      text-align: left;
    }
    .hover-tooltip-80{
      left:0;
    }
    .hover-tooltip-95{
      right: 0;
    }
    &:hover{
      border: 1px solid #F4F4F4 !important;
      .hover-tooltip{
        display: block;
      }
    }
  }
  .common-tips {
    width: 100%;
    height: 60px;
    padding: 0 14px;
    box-sizing: border-box;
    background: #F9F9F9;
    border-radius: 4px;
    margin-bottom: 19px;
    font-size: 14px;
    font-weight: 400;
    color: #9C9C9C;
    line-height: 20px;
  }
</style>

<style lang="scss">
  .edit-cv-main {
    .el-select {
      width: 100%;
      height: 38px !important;
      .el-input__inner,
      .el-input {
        border-radius: 4px;
        height: 100%;
        border-color: #ECECEC !important;
      }
    }
  }
</style>
